module.exports = __webpack_public_path__ + "static/img/b9.f74a696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/b9.png
// module id = R0iP
// module chunks = 0